import React from "react"
import priceTagBlack from "../../../images/price-tag-black.svg"
import { Image } from "semantic-ui-react"

export function PricedAtShop({ fontSize }) {
  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "5px", fontSize: fontSize }}>
      <Image src={priceTagBlack} />
      <p style={{ fontWeight: "bold", margin: 0, color: "#282828" }}>Priced at shop</p>
    </div>
  )
}
